import React from 'react';
import {Container, Box} from '@mui/material';
import Button from "@mui/material/Button";
import {LinkedIn, Newspaper} from "@mui/icons-material";
import SportsBasketballIcon from '@mui/icons-material/SportsBasketball';
import InstagramIcon from '@mui/icons-material/Instagram';

const CONTACTS = [
    {icon: <LinkedIn/>, name: 'LinkedIn', link: "https://www.linkedin.com/in/tatiana-vantaggiato/"},
    {icon: <Newspaper/>, name: 'Resume (CV)', link: "/assets/images/CV-Tatiana Vantaggiato.pdf"},
    {icon: <InstagramIcon/>, name: 'Instagram', link: "https://www.instagram.com/uxui.tatiana/"},
    {icon: <SportsBasketballIcon/>, name: 'Dribbble', link: "https://dribbble.com/Vantaggiato"},
];
function Contacts() {

    const handleClick = (link) => {
        window.open(link, '_blank');
    };

    const contactSx = {
        color: 'text.primary',
        '&:hover': {
            backgroundColor: 'action.hover',
        },
    }

    return (
        <Container sx={{padding: '64px 0', overflow: 'hidden'}}>
            {/*<SectionTitle title={'Contacts'} />*/}
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                flexWrap: 'wrap',
                gap: {xs: '24px', sm: '32px 64px'},
                flexDirection: {xs: 'column', sm: 'row'}
            }}>
                {CONTACTS.map(({icon, name, link}) =>
                    <Button size="large" sx={contactSx} startIcon={icon} onClick={() => handleClick(link)}>
                        {name}
                    </Button>
                )}
            </Box>
        </Container>
    );
}

export default Contacts;